import moment from "moment";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "../../button/Button";
import { ShieldLogo } from "../../graphic/ShieldLogo/ShieldLogo";
import Col from "../../grid/Col";
import Row from "../../grid/Row";
import { PageMessage } from "../../page/PageMessage";
import { Text } from "../../typography/Text";
import { MissingSubscription } from "./parts/MissingSubscription";
import { Trialing } from "./parts/Trialing";

const msgKey = "accountActivationMessage";

export const AccountActivationMessage = ({
    account,
    accountRole,
    accountName,
    manageSubscriptionLink,
    chooseSubscriptionLink
}) => {
    const activeDays = parseInt(moment(account.activeDate).diff(moment(), "days"), 10);

    // General message for non-owners
    if (accountRole !== "OWNER") {
        return <MissingSubscription accountName={accountName} />;
    }

    // Trialing
    if (account.status === "TRIAL") {
        return <Trialing account={account} accountName={accountName} chooseSubscriptionLink={chooseSubscriptionLink} />;
    }

    // Create subscription
    return (
        <PageMessage
            title={<FormattedMessage id={`${msgKey}.buySubscriptionTitle`} />}
            figure={<ShieldLogo size={100} />}
        >
            <Row gutter={["large", "large"]}>
                <Col span={24}>
                    <Text block size="medium" color="base80">
                        <FormattedMessage
                            id={`${msgKey}.buySubscriptionMessage`}
                            values={{ name: accountName, strong: (msg) => <strong>{msg}</strong> }}
                        />
                    </Text>
                </Col>
                {activeDays > 0 ? (
                    <Col span={24}>
                        <Text color="base60">
                            <FormattedMessage id={`${msgKey}.accessDaysLeft`} values={{ days: activeDays }} />
                        </Text>
                    </Col>
                ) : null}
                <Col span={24} align={["center", "top"]}>
                    {account.status === "SUBSCRIPTION" ? (
                        <Button fill link={manageSubscriptionLink} iconColor="success" icon="ticket" size="big">
                            <FormattedMessage id={`${msgKey}.manageSubscription`} />
                        </Button>
                    ) : (
                        <Button fill link={chooseSubscriptionLink} color="success" icon="ticket" size="big">
                            <FormattedMessage id={`${msgKey}.chooseSubscription`} />
                        </Button>
                    )}
                </Col>
            </Row>
        </PageMessage>
    );
};
